module.exports = __webpack_public_path__ + "static/media/child1.e6e1eb15.png";